module.exports = __webpack_public_path__ + "img/quizLists.616f69a2.png";